import React from "react";
const { kebabCase } = require("lodash");

const TwemojiComponent = ({ emoji, size = 'twa-lg', className }) => {
  const twaClass = kebabCase(emoji)
  return <i className={`twa ${size} twa-${twaClass} ${className ? className : ""}`} />
}

export default TwemojiComponent